(function () {
  'use strict';

  var CHANNEL_LABELS = {
    strongant: 'strongant.de',
    amazon: 'Amazon',
    other: 'Extern',
  };
  var CASHBACK_STATUS = {
    reserved: { label: 'Vorgemerkt', cls: 'saacc__badge--warn' },
    pending: { label: 'In Prüfung', cls: 'saacc__badge--warn' },
    available: { label: 'Verfügbar', cls: 'saacc__badge--ok' },
    approved: { label: 'Verfügbar', cls: 'saacc__badge--ok' },
    redeemed: { label: 'Eingelöst', cls: 'saacc__badge--muted' },
    rejected: { label: 'Abgelehnt', cls: 'saacc__badge--muted' },
  };

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }

  function money(value, currency) {
    if (value == null || value === '') return null;
    var num = Number(value);
    if (!Number.isFinite(num)) return null;
    try {
      return num.toLocaleString('de-DE', { style: 'currency', currency: currency || 'EUR' });
    } catch (e) {
      return num.toFixed(2) + ' ' + (currency || 'EUR');
    }
  }

  function euro(value) {
    if (value == null || value === '') return null;
    var num = Number(value);
    if (!Number.isFinite(num)) return null;
    return num.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  function setKpi(root, key, value) {
    var node = root.querySelector('[data-saacc-kpi="' + key + '"]');
    if (node) node.textContent = value;
  }

  function showError(container, message) {
    container.textContent = '';
    container.setAttribute('role', 'alert');
    container.appendChild(el('p', 'saacc__err', message || 'Dieser Bereich ist gerade nicht verfügbar.'));
  }

  function showMuted(container, message) {
    container.textContent = '';
    container.setAttribute('role', 'status');
    container.appendChild(el('p', 'saacc__muted', message));
  }

  function sanitizeCustomerTitle(title) {
    var out = String(title || '').trim();
    out = out.split(' (Petrach e.K.)').join('');
    out = out.split(' (diearbeitsbekleidung)').join('');
    out = out.split(' (Nawaz (Pakistan))').join('');
    out = out.replace(/\s*\(EMB-(?:PET|DAB|NAW|SHOP)-(?:NAM|FRT|BCK|FUL)\)\s*$/i, '');
    return out.replace(/\s{2,}/g, ' ').trim();
  }

  function customerLineLabel(item, order) {
    var title = sanitizeCustomerTitle(item.title);
    var variant = item.variantTitle && !/^EMB-(?:PET|DAB|NAW|SHOP)-/i.test(String(item.variantTitle))
      ? item.variantTitle
      : null;
    var label = item.quantity + '× ' + title + (variant ? ' (' + variant + ')' : '');
    if (item.lineTotal) label += ' · ' + money(item.lineTotal, order.currency);
    return label;
  }

  function openOrderDetails(detailsEl) {
    if (!detailsEl) return;
    detailsEl.open = true;
    detailsEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function normalizeOrderRef(value) {
    return String(value || '').trim().replace(/^#/, '').toLowerCase();
  }

  function focusOrderFromQuery(container) {
    var params = new URLSearchParams(window.location.search);
    var orderRef = params.get('order') || params.get('bestellung');
    if (!orderRef || !container) return;
    var target = container.querySelector('[data-order-ref="' + normalizeOrderRef(orderRef) + '"]');
    if (target) openOrderDetails(target);
  }

  function threadColorHex(code, options) {
    var colors = (options && options.threadColors) || [];
    for (var i = 0; i < colors.length; i++) {
      if (colors[i].code === code) return colors[i].hex;
    }
    return '#111111';
  }

  function catalogLabel(code, options, key) {
    var list = (options && options[key]) || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].code === code) return list[i].label;
    }
    return code;
  }

  function previewBaseUrl(root) {
    return String((root && root.getAttribute('data-saacc-preview-url')) || 'https://brain.petrach.de/api/v2/public/strongant/veredelung/preview').replace(/\/+$/, '');
  }

  function addLogoPreviewBlock(block, manifest, logo, options, root) {
    var label = logo.placement === 'logo_back' ? 'Logo hinten' : 'Logo vorne';
    if (!manifest.sessionId) return;
    var wrap = el('div', 'saacc__preview-block');
    wrap.appendChild(el('strong', 'saacc__preview-label', label + ' – Vorschau & Simulation'));
    var tabs = el('div', 'saacc__preview-tabs');
    var img = el('img', 'saacc__order-preview');
    img.alt = label + ' für ' + manifest.designId;
    img.loading = 'lazy';
    var base =
      previewBaseUrl(root) +
      '?sessionId=' + encodeURIComponent(manifest.sessionId) +
      '&placement=' + encodeURIComponent(logo.placement) +
      '&widthCm=' + encodeURIComponent(String(logo.widthCm)) +
      '&heightCm=' + encodeURIComponent(String(logo.heightCm));
    var btnProduct = el('button', 'saacc__preview-tab is-active', 'Produktvorschau');
    var btnAi = el('button', 'saacc__preview-tab', 'Simulation');
    btnProduct.type = 'button';
    btnAi.type = 'button';
    function setMode(mode) {
      img.src = base + '&mode=' + encodeURIComponent(mode) + '&t=' + Date.now();
      btnProduct.classList.toggle('is-active', mode === 'product');
      btnAi.classList.toggle('is-active', mode === 'ai');
    }
    img.addEventListener('error', function () {
      var note = el('p', 'saacc__muted', 'Vorschau gerade nicht verfügbar. Bitte Seite neu laden oder Support kontaktieren.');
      if (img.parentNode) img.parentNode.replaceChild(note, img);
    });
    btnProduct.addEventListener('click', function () { setMode('product'); });
    btnAi.addEventListener('click', function () { setMode('ai'); });
    tabs.appendChild(btnProduct);
    tabs.appendChild(btnAi);
    wrap.appendChild(tabs);
    wrap.appendChild(img);
    block.appendChild(wrap);
    setMode('product');
  }

  function orderSummaryBlock(order) {
    var box = el('section', 'saacc__order-summary');
    box.appendChild(el('h3', 'saacc__summary-title', 'Bestellübersicht'));
    var lines = el('div', 'saacc__summary-lines');
    var subtotal = 0;
    (order.lineItems || []).forEach(function (item) {
      if (item.lineTotal) subtotal += Number(item.lineTotal);
      lines.appendChild(
        valueLine(
          item.quantity + '× ' + sanitizeCustomerTitle(item.title),
          money(item.lineTotal, order.currency)
        )
      );
    });
    box.appendChild(lines);
    if (subtotal > 0) {
      box.appendChild(valueLine('Zwischensumme', money(subtotal.toFixed(2), order.currency)));
    }
    box.appendChild(valueLine('Gesamtbetrag', money(order.totalPrice, order.currency)));
    if (order.expectedTotalPrice && String(order.expectedTotalPrice) !== String(order.totalPrice)) {
      box.appendChild(valueLine('Vollständiger Auftragswert', money(order.expectedTotalPrice, order.currency)));
    }
    box.appendChild(valueLine('Bestellstatus', customerOrderStatus(order)));
    return box;
  }

  function customerOrderStatus(order) {
    if (order.cancelled) return 'Storniert';
    if (order.paymentBlocked) return 'Zahlung vorübergehend gesperrt – Betrag wird geprüft';
    if (order.vorkasseOpen) return 'Zahlung erforderlich';
    if (order.fulfillmentStatus === 'fulfilled') return 'Versendet';
    if (order.financialStatus === 'paid') return 'Bezahlt · In Bearbeitung';
    return order.statusLabel || 'In Bearbeitung';
  }

  function valueLine(label, value) {
    var row = el('div', 'saacc__detail-line');
    row.appendChild(el('span', null, label));
    row.appendChild(el('strong', null, value || '—'));
    return row;
  }

  var SHORTFALL_LABELS = {
    wait_original: 'Auf Originalartikel warten',
    alternative: 'Alternative wählen',
    partial_ship: 'Verfügbares zuerst senden',
    cancel_line: 'Betroffene Position stornieren',
    cancel_order: 'Gesamte Bestellung stornieren',
  };

  function shortfallPrice(preview) {
    if (!preview) return '';
    if (Number(preview.refundCents) > 0) {
      return 'Voraussichtliche Erstattung: ' + money(Number(preview.refundCents) / 100, preview.currency);
    }
    return preview.explanation || 'Keine zusätzliche Zahlung.';
  }

  function renderStockShortfalls(container, cases, unavailable, actionUrl) {
    if (!container) return;
    if (unavailable) return showError(container, 'Offene Lieferoptionen sind gerade nicht verfügbar.');
    if (!cases || !cases.length) {
      container.closest('.saacc__card').hidden = true;
      return;
    }
    container.closest('.saacc__card').hidden = false;
    container.textContent = '';
    cases.forEach(function (shortfall) {
      var card = el('article', 'saacc__line-card');
      card.appendChild(el('strong', null, shortfall.orderName + ' · Artikel ' + shortfall.sku));
      card.appendChild(el('p', 'saacc__muted', 'Für ' + shortfall.quantityShort + ' Stück brauchen wir deine Entscheidung. Angebote können 48 Stunden reserviert sein.'));
      if (shortfall.personalized) {
        var gate = el('div', 'saacc__notice saacc__notice--warn');
        gate.appendChild(el('strong', null, 'Personalisierung geschützt'));
        gate.appendChild(el('span', null, 'Alternativen sind nur auswählbar, wenn die Personalisierung sicher übernommen werden kann.'));
        card.appendChild(gate);
      }
      var form = el('form', 'saacc__edit-form');
      (shortfall.options || []).forEach(function (option, index) {
        var label = el('label', 'saacc__addr');
        var radio = el('input');
        radio.type = 'radio';
        radio.name = 'optionId';
        radio.value = option.id;
        radio.required = true;
        radio.disabled = option.kind === 'alternative' &&
          (Number(option.availableQuantity || 0) < Number(shortfall.quantityShort) ||
           (shortfall.personalized && !option.personalizationCompatible));
        if (index === 0 && !radio.disabled) radio.checked = true;
        label.appendChild(radio);
        label.appendChild(document.createTextNode(' ' + (option.title || SHORTFALL_LABELS[option.kind] || option.kind)));
        label.appendChild(el('small', null, option.description));
        label.appendChild(el('small', 'saacc__muted', shortfallPrice(option.pricePreview)));
        if (option.kind === 'alternative' && option.availableQuantity != null) {
          label.appendChild(el('small', null, option.availableQuantity + ' Stück aktuell reservierbar'));
        }
        form.appendChild(label);
      });
      var submit = el('button', 'saacc__btn saacc__btn--primary saacc__btn--sm', 'Auswahl verbindlich speichern');
      submit.type = 'submit';
      form.appendChild(submit);
      var status = el('span', 'saacc__size-status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var selected = form.querySelector('input[name="optionId"]:checked');
        if (!selected) {
          status.className = 'saacc__size-status is-err';
          status.textContent = 'Bitte eine verfügbare Option wählen.';
          return;
        }
        if (!window.crypto || typeof window.crypto.randomUUID !== 'function') {
          status.className = 'saacc__size-status is-err';
          status.textContent = 'Sicheres Speichern wird von diesem Browser nicht unterstützt.';
          return;
        }
        submit.disabled = true;
        status.className = 'saacc__size-status';
        status.textContent = 'Auswahl wird sicher gespeichert …';
        var key = 'portal:' + window.crypto.randomUUID();
        fetch(actionUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'Idempotency-Key': key },
          credentials: 'same-origin',
          cache: 'no-store',
          body: JSON.stringify({ caseId: shortfall.id, optionId: selected.value }),
        })
          .then(function (response) {
            return response.json().then(function (payload) {
              if (!response.ok || !payload.success) throw new Error(payload.error || 'Speichern fehlgeschlagen.');
              return payload;
            });
          })
          .then(function (payload) {
            status.className = 'saacc__size-status is-ok';
            status.textContent = payload.data.message;
            submit.textContent = 'Gespeichert';
            form.querySelectorAll('input').forEach(function (input) { input.disabled = true; });
          })
          .catch(function (error) {
            status.className = 'saacc__size-status is-err';
            status.textContent = error.message || 'Speichern fehlgeschlagen.';
            submit.disabled = false;
          });
      });
      card.appendChild(form);
      container.appendChild(card);
    });
  }

  function personalizationBlock(item, change, actionUrl, uploadUrl, order, options, root) {
    var manifest = change && change.requestedManifest ? change.requestedManifest : item.personalization;
    if (!manifest) return null;
    var block = el('section', 'saacc__personalization');
    var head = el('div', 'saacc__personalization-head');
    head.appendChild(el('strong', null, 'Veredelung · ' + manifest.designId));
    head.appendChild(el('span', 'saacc__badge saacc__badge--muted', manifest.customerApproved ? 'Freigegeben' : 'Freigabe offen'));
    block.appendChild(head);
    block.appendChild(valueLine('Liefermodell', manifest.tempo === 'planned' ? 'Geplante Produktion (3–4 Wochen)' : 'Schnelle Veredelung'));
    block.appendChild(valueLine('Lieferhinweis', manifest.deliveryNote));
    if (manifest.name) {
      block.appendChild(valueLine('Name / Text', manifest.name.text));
      block.appendChild(valueLine('Schriftart', catalogLabel(manifest.name.fontCode, options, 'fonts')));
      block.appendChild(valueLine('Garnfarbe', catalogLabel(manifest.name.threadColor, options, 'threadColors')));
      var nameSim = el('div', 'saacc__preview-block');
      nameSim.appendChild(el('strong', 'saacc__preview-label', 'Namens-Simulation'));
      var namePreview = el('span', 'saacc__name-preview');
      namePreview.textContent = manifest.name.text;
      namePreview.style.color = threadColorHex(manifest.name.threadColor, options);
      nameSim.appendChild(namePreview);
      nameSim.appendChild(
        el(
          'small',
          'saacc__muted',
          'So wird der Name auf der Jacke platziert (Schrift ' +
            catalogLabel(manifest.name.fontCode, options, 'fonts') +
            ', Garn ' +
            catalogLabel(manifest.name.threadColor, options, 'threadColors') +
            ').'
        )
      );
      block.appendChild(nameSim);
    }
    (manifest.logos || []).forEach(function (logo) {
      var label = logo.placement === 'logo_back' ? 'Logo hinten' : 'Logo vorne';
      block.appendChild(valueLine(label, logo.widthCm + ' × ' + logo.heightCm + ' cm · Farben aus Logo-Datei'));
      addLogoPreviewBlock(block, manifest, logo, options, root);
    });
    block.appendChild(valueLine('Design-Version', manifest.designId));
    block.appendChild(valueLine('Kundenfreigabe', manifest.customerApprovedAt ? formatDate(manifest.customerApprovedAt) : 'Noch nicht freigegeben'));

    if (change) {
      var syncFailed = change.status === 'sync_failed';
      var pending = el('div', 'saacc__notice ' + (syncFailed ? 'saacc__notice--error' : 'saacc__notice--warn'));
      pending.appendChild(el('strong', null, (syncFailed ? 'Änderung braucht sofortige Prüfung · ' : 'Änderung gespeichert · ') + change.designId));
      pending.appendChild(el('span', null, syncFailed ? 'Die technische Produktionssperre konnte nicht bestätigt werden. Bitte Support kontaktieren.' : 'Die Produktion bleibt bis zur Prüfung gesperrt.'));
      block.appendChild(pending);
    }

    if ((manifest.name || (manifest.logos || []).length) && item.id && !order.cancelled && order.fulfillmentStatus !== 'fulfilled') {
      var edit = el('details', 'saacc__edit');
      edit.appendChild(el('summary', null, change ? 'Änderung erneut bearbeiten' : 'Veredelung bearbeiten'));
      var form = el('form', 'saacc__edit-form');
      if (manifest.name) {
        var nameLabel = el('label', null, 'Name / Text');
        var nameInput = el('input', 'saacc__input');
        nameInput.name = 'nameText';
        nameInput.value = manifest.name.text || '';
        nameInput.required = true;
        nameInput.maxLength = 60;
        nameLabel.appendChild(nameInput);
        form.appendChild(nameLabel);
        [
          ['fontCode', 'Schriftart', (options && options.fonts) || [], manifest.name.fontCode],
          ['threadColor', 'Garnfarbe', (options && options.threadColors) || [], manifest.name.threadColor],
        ].forEach(function (field) {
          var label = el('label', null, field[1]);
          var select = el('select', 'saacc__input');
          select.name = field[0];
          select.required = true;
          field[2].forEach(function (option) {
            var node = el('option', null, option.label);
            node.value = option.code;
            node.selected = option.code === field[3];
            select.appendChild(node);
          });
          label.appendChild(select);
          form.appendChild(label);
        });
      }
      (manifest.logos || []).forEach(function (logo) {
        var logoLabel = el('label', null, (logo.placement === 'logo_back' ? 'Logo hinten' : 'Logo vorne') + ' ersetzen (optional)');
        var file = el('input', 'saacc__input');
        file.type = 'file';
        file.name = 'logo_' + logo.placement;
        file.accept = '.png,.jpg,.jpeg,.webp,.svg,application/pdf';
        logoLabel.appendChild(file);
        form.appendChild(logoLabel);
      });
      var note = el('p', 'saacc__muted', 'Eine Änderung erzeugt eine neue Design-Version. Die Produktion bleibt bis zur Prüfung gesperrt.');
      form.appendChild(note);
      var submit = el('button', 'saacc__btn saacc__btn--primary saacc__btn--sm', 'Änderung speichern');
      submit.type = 'submit';
      form.appendChild(submit);
      var status = el('span', 'saacc__size-status');
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      form.appendChild(status);
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (!actionUrl) {
          status.className = 'saacc__size-status is-err';
          status.textContent = 'Bearbeitung ist nicht konfiguriert.';
          return;
        }
        submit.disabled = true;
        status.className = 'saacc__size-status';
        status.textContent = 'Änderung wird sicher gespeichert …';
        var data = new FormData(form);
        var uploads = (manifest.logos || []).map(function (logo) {
          var file = data.get('logo_' + logo.placement);
          if (!(file instanceof File) || !file.size) return Promise.resolve(null);
          if (!uploadUrl) return Promise.reject(new Error('Logo-Upload ist nicht konfiguriert.'));
          var upload = new FormData();
          upload.append('sessionId', manifest.sessionId);
          upload.append('placement', logo.placement);
          upload.append('file', file);
          return fetch(uploadUrl, {
            method: 'POST',
            body: upload,
            credentials: 'omit',
            cache: 'no-store',
          }).then(function (res) {
            return res.json().then(function (payload) {
              if (!res.ok || !payload.success) throw new Error(payload.error || 'Logo-Upload fehlgeschlagen.');
              return { placement: logo.placement, assetId: payload.data.assetId };
            });
          });
        });
        Promise.all(uploads)
          .then(function (uploaded) {
            var logoUpdates = {};
            uploaded.filter(Boolean).forEach(function (entry) { logoUpdates[entry.placement] = entry.assetId; });
            return fetch(actionUrl, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              credentials: 'same-origin',
              cache: 'no-store',
              body: JSON.stringify({
                orderId: String(order.id),
                lineItemId: item.id,
                nameText: String(data.get('nameText') || ''),
                fontCode: String(data.get('fontCode') || ''),
                threadColor: String(data.get('threadColor') || ''),
                logoUpdates: logoUpdates,
              }),
            });
          })
          .then(function (res) {
            return res.json().then(function (payload) {
              if (!res.ok || !payload.success) throw new Error(payload.error || 'Speichern fehlgeschlagen.');
              return payload;
            });
          })
          .then(function (payload) {
            status.className = 'saacc__size-status is-ok';
            status.textContent = payload.data.message;
            submit.textContent = 'Gespeichert';
          })
          .catch(function (error) {
            status.className = 'saacc__size-status is-err';
            status.textContent = error.message || 'Speichern fehlgeschlagen.';
            submit.disabled = false;
          });
      });
      edit.appendChild(form);
      block.appendChild(edit);
    }
    return block;
  }

  function orderTimeline(order) {
    var timeline = el('ol', 'saacc__timeline');
    var stages = [
      { label: 'Bestellung eingegangen', done: true },
      { label: order.financialStatus === 'paid' ? 'Zahlung erhalten' : 'Zahlung offen', done: order.financialStatus === 'paid' },
      { label: 'Produktion / Kommissionierung', done: order.fulfillmentStatus === 'fulfilled' },
      { label: order.fulfillmentStatus === 'fulfilled' ? 'Versendet' : 'Versand folgt', done: order.fulfillmentStatus === 'fulfilled' },
    ];
    stages.forEach(function (stage) {
      var node = el('li', stage.done ? 'is-done' : '');
      node.appendChild(el('span', 'saacc__timeline-dot'));
      node.appendChild(el('strong', null, stage.label));
      timeline.appendChild(node);
    });
    return timeline;
  }

  function renderOrders(container, orders, unavailable, changes, actionUrl, uploadUrl, profile, personalizationOptions, root) {
    if (unavailable) return showError(container, 'Bestellungen sind gerade nicht verfügbar.');
    if (!orders || !orders.length) {
      container.textContent = '';
      container.setAttribute('role', 'status');
      container.appendChild(el('p', 'saacc__muted', 'Noch keine Bestellungen vorhanden.'));
      var shopLink = el('a', 'saacc__btn saacc__btn--primary saacc__btn--sm', 'Produkte entdecken');
      shopLink.href = '/collections/all';
      container.appendChild(shopLink);
      return;
    }
    container.textContent = '';
    var changeList = changes || [];
    orders.forEach(function (order) {
      var details = el('details', 'saacc__order-detail');
      details.setAttribute('data-order-ref', normalizeOrderRef(order.orderNumber));
      var row = el('div', 'saacc__row');

      var main = el('div', 'saacc__row-main');
      var title = el('strong', null, order.orderNumber + ' · ' + formatDate(order.createdAt));
      main.appendChild(title);
      main.appendChild(el('small', null, order.itemCount + ' Artikel'));

      var items = el('ul', 'saacc__items');
      (order.lineItems || []).slice(0, 4).forEach(function (item) {
        items.appendChild(el('li', null, customerLineLabel(item, order)));
      });
      if ((order.lineItems || []).length > 4) {
        items.appendChild(el('li', null, '+ ' + (order.lineItems.length - 4) + ' weitere'));
      }
      main.appendChild(items);

      (order.tracking || []).forEach(function (track) {
        var wrap = el('p', 'saacc__track');
        var prefix = 'Sendung' + (track.company ? ' (' + track.company + ')' : '') + ': ';
        wrap.appendChild(document.createTextNode(prefix));
        if (track.url) {
          var link = el('a', null, track.number || 'verfolgen');
          link.href = track.url;
          link.target = '_blank';
          link.rel = 'noreferrer';
          wrap.appendChild(link);
        } else {
          wrap.appendChild(document.createTextNode(track.number || '—'));
        }
        main.appendChild(wrap);
      });
      row.appendChild(main);

      var side = el('div', 'saacc__row-side');
      var badgeCls = order.cancelled
        ? 'saacc__badge--muted'
        : order.vorkasseOpen
        ? 'saacc__badge--warn'
        : 'saacc__badge--ok';
      side.appendChild(el('span', 'saacc__badge ' + badgeCls, customerOrderStatus(order)));
      var price = money(order.totalPrice, order.currency);
      if (price && Number(order.totalPrice) > 0) side.appendChild(el('span', 'saacc__price', price));
      if (order.paymentBlocked) {
        var blockedDetails = el('button', 'saacc__btn saacc__btn--ghost saacc__btn--sm', 'Grund anzeigen');
        blockedDetails.type = 'button';
        blockedDetails.addEventListener('click', function () {
          openOrderDetails(details);
        });
        side.appendChild(blockedDetails);
      } else if (order.vorkasseOpen && order.orderStatusUrl) {
        var pay = el('a', 'saacc__btn saacc__btn--primary saacc__btn--sm', 'Jetzt bezahlen');
        pay.href = order.orderStatusUrl;
        side.appendChild(pay);
      } else {
        var view = el('button', 'saacc__btn saacc__btn--ghost saacc__btn--sm', 'Bestelldetails');
        view.type = 'button';
        view.addEventListener('click', function () {
          openOrderDetails(details);
        });
        side.appendChild(view);
      }
      if (order.reorderUrl) {
        var reorder = el('a', 'saacc__btn saacc__btn--ghost saacc__btn--sm', 'Nachbestellen');
        reorder.href = order.reorderUrl;
        side.appendChild(reorder);
      }
      row.appendChild(side);

      container.appendChild(row);

      details.appendChild(el('summary', null, 'Alle Bestelldetails anzeigen'));
      var detailBody = el('div', 'saacc__order-detail-body');
      if (order.paymentBlocked) {
        var integrity = el('div', 'saacc__notice saacc__notice--error');
        integrity.appendChild(el('strong', null, 'Bitte noch nicht bezahlen'));
        integrity.appendChild(el('span', null, order.dataIntegrityMessage || 'Die Gesamtbeträge stimmen noch nicht überein.'));
        if (order.expectedTotalPrice) {
          integrity.appendChild(el('span', null, 'Vollständiger Auftragswert: ' + money(order.expectedTotalPrice, order.currency)));
        }
        detailBody.appendChild(integrity);
      }
      detailBody.appendChild(orderTimeline(order));
      (order.lineItems || []).forEach(function (item) {
        var itemCard = el('article', 'saacc__line-card');
        var itemHead = el('div', 'saacc__line-card-head');
        itemHead.appendChild(el('strong', null, item.quantity + '× ' + sanitizeCustomerTitle(item.title)));
        var itemMeta = el('div', 'saacc__row-side');
        itemMeta.appendChild(
          el(
            'span',
            'saacc__badge ' + (item.withdrawalEligible ? 'saacc__badge--ok' : 'saacc__badge--muted'),
            item.withdrawalEligible ? 'Standardware' : 'Individuell angefertigt'
          )
        );
        if (item.lineTotal) itemMeta.appendChild(el('span', 'saacc__price', money(item.lineTotal, order.currency)));
        itemHead.appendChild(itemMeta);
        itemCard.appendChild(itemHead);
        if (item.sku && !/^EMB-/i.test(String(item.sku))) {
          itemCard.appendChild(valueLine('Artikelnummer', item.sku));
        }
        if (item.unitPrice) itemCard.appendChild(valueLine('Einzelpreis', money(item.unitPrice, order.currency)));
        var humanVeredelungNames = {
          'Liefermodell': 1,
          'Veredelung': 1,
          'Name / Text': 1,
          'Schriftart': 1,
          'Garnfarbe (Name)': 1,
          'Logo vorne (Brust)': 1,
          'Logo hinten (Rücken)': 1,
          'Freigabe': 1,
          'Lieferzeit': 1,
          'Design-Nr.': 1,
          'Veredelung gesamt': 1,
        };
        (item.properties || []).filter(function (property) {
          if (!property.visible) return false;
          // Veredelungsdetails kommen im strukturierten Block darunter — keine Doppelanzeige.
          if (item.personalization && humanVeredelungNames[property.name]) return false;
          return true;
        }).forEach(function (property) {
          itemCard.appendChild(valueLine(property.name, property.value));
        });
        if (item.personalizationError) {
          var malformed = el('div', 'saacc__notice saacc__notice--error');
          malformed.appendChild(el('strong', null, 'Veredelungsdaten müssen geprüft werden'));
          malformed.appendChild(el('span', null, item.personalizationError));
          itemCard.appendChild(malformed);
        }
        var change = changeList.find(function (candidate) {
          return String(candidate.shopifyOrderId) === String(order.id) &&
            String(candidate.lineItemId) === String(item.id) &&
            (candidate.status === 'pending' || candidate.status === 'sync_failed');
        });
        var personalization = personalizationBlock(item, change, actionUrl, uploadUrl, order, personalizationOptions, root);
        if (personalization) itemCard.appendChild(personalization);
        detailBody.appendChild(itemCard);
      });
      var eligibleCount = (order.lineItems || []).filter(function (item) {
        return item.withdrawalEligible;
      }).length;
      var excludedCount = (order.lineItems || []).length - eligibleCount;
      var legal = el('p', 'saacc__legal');
      if (eligibleCount && excludedCount) {
        legal.textContent = 'Diese Bestellung enthält Standardware und individuell angefertigte Ware. Online widerrufen kannst du nur die als Standardware gekennzeichneten Positionen.';
      } else if (excludedCount) {
        legal.textContent = 'Individuell angefertigte Ware: Der gesetzliche Widerruf ist grundsätzlich ausgeschlossen (§ 312g Abs. 2 Nr. 1 BGB). Bei einem Mangel hilft dir unser Support.';
      } else {
        legal.textContent = 'Diese Bestellung enthält widerrufsfähige Standardware.';
      }
      detailBody.appendChild(legal);
      detailBody.appendChild(orderSummaryBlock(order));
      var canWithdraw =
        order.source === 'shopify' &&
        !order.cancelled &&
        (order.lineItems || []).some(function (item) {
          return item.withdrawalEligible;
        });
      if (canWithdraw) {
        var actions = el('div', 'saacc__detail-actions');
        var withdrawal = el('a', 'saacc__btn saacc__btn--ghost saacc__btn--sm', 'Widerruf für Standardware');
        withdrawal.href = '/pages/widerruf?order=' + encodeURIComponent(order.orderNumber) +
          (profile && profile.email ? '&email=' + encodeURIComponent(profile.email) : '');
        actions.appendChild(withdrawal);
        detailBody.appendChild(actions);
      }
      details.appendChild(detailBody);
      container.appendChild(details);
    });
    focusOrderFromQuery(container);
  }

  function renderComms(container, root, comms, commsUrl) {
    if (!container) return;
    container.textContent = '';
    var threads = (comms && comms.threads) || [];
    if (!threads.length) {
      return showMuted(container, 'Keine offenen Nachrichten. Unser Team meldet sich hier oder per E-Mail.');
    }

    threads.forEach(function (thread) {
      var details = el('details', 'saacc__addr');
      if (thread.waitingForCustomer) details.open = true;
      var summary = el('summary', null, null);
      summary.appendChild(el('strong', null, thread.orderName || ('Bestellung ' + thread.orderId)));
      if (thread.waitingForCustomer) {
        summary.appendChild(el('span', 'saacc__badge saacc__badge--warn', 'Antwort nötig'));
      }
      details.appendChild(summary);

      var last = thread.lastMessage;
      if (last) {
        details.appendChild(el('small', null, (last.direction === 'out' ? 'strongAnt: ' : 'Du: ') + last.body));
      }

      var form = el('form', 'saacc__size-form');
      var input = el('textarea', 'saacc__input');
      input.name = 'body';
      input.rows = 3;
      input.required = true;
      input.placeholder = 'Antwort schreiben …';
      form.appendChild(input);
      var btn = el('button', 'saacc__btn saacc__btn--primary saacc__btn--sm', 'Senden');
      btn.type = 'submit';
      form.appendChild(btn);
      var status = el('span', 'saacc__size-status');
      form.appendChild(status);

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var text = String(input.value || '').trim();
        if (!text || !commsUrl) return;
        status.textContent = 'Wird gesendet …';
        btn.disabled = true;
        fetch(commsUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ orderId: thread.orderId, body: text }),
        })
          .then(function (response) { return response.json().then(function (json) { return { response: response, json: json }; }); })
          .then(function (result) {
            if (!result.response.ok || !result.json || !result.json.success) {
              throw new Error((result.json && result.json.error) || 'Senden fehlgeschlagen');
            }
            input.value = '';
            status.textContent = 'Gesendet.';
            load(root, 0);
          })
          .catch(function (error) {
            status.textContent = error instanceof Error ? error.message : 'Senden fehlgeschlagen';
          })
          .finally(function () {
            btn.disabled = false;
          });
      });

      details.appendChild(form);
      container.appendChild(details);
    });
  }

  function startCommsPresence(root, commsUrl) {
    if (!commsUrl || root.getAttribute('data-saacc-comms-ping') === '1') return;
    root.setAttribute('data-saacc-comms-ping', '1');
    window.setInterval(function () {
      fetch(commsUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ ping: true }),
      }).catch(function () {});
    }, 120000);
  }

  function renderCashback(container, cashback, unavailable) {
    if (unavailable) return showError(container, 'Cashback ist gerade nicht verfügbar.');
    if (!cashback) return showMuted(container, 'Kein Cashback vorhanden.');
    container.textContent = '';

    var head = el('div', 'saacc__row');
    var main = el('div', 'saacc__row-main');
    main.appendChild(
      el('strong', null, (euro(cashback.availableEuros || cashback.balanceEuros) || '0,00 €') + ' verfügbar')
    );
    var summaryParts = [];
    if (cashback.reservedCount > 0) {
      summaryParts.push(
        (euro(cashback.reservedEuros) || '0,00 €') + ' vorgemerkt (' + cashback.reservedCount + ')'
      );
    }
    if (cashback.pendingCount > 0) {
      summaryParts.push(cashback.pendingCount + ' in Prüfung');
    }
    if (cashback.redeemedCount > 0) {
      summaryParts.push(cashback.redeemedCount + ' eingelöst');
    }
    main.appendChild(el('small', null, summaryParts.length ? summaryParts.join(' · ') : 'Nach Zahlung 3 % als Gutschein'));
    head.appendChild(main);
    container.appendChild(head);

    if (!cashback.claims || !cashback.claims.length) {
      container.appendChild(
        el(
          'p',
          'saacc__muted',
          cashback.reservedCount > 0
            ? 'Cashback wird nach Zahlung automatisch freigegeben.'
            : 'Noch keine Cashback-Vorgänge.'
        )
      );
      return;
    }
    cashback.claims.forEach(function (claim) {
      var row = el('div', 'saacc__row');
      var m = el('div', 'saacc__row-main');
      m.appendChild(el('strong', null, claim.orderReference));
      m.appendChild(
        el('small', null, (CHANNEL_LABELS[claim.channel] || claim.channel) + ' · ' + formatDate(claim.purchaseDate))
      );
      if (claim.discountCode) {
        m.appendChild(el('span', 'saacc__code', 'Code: ' + claim.discountCode));
      }
      row.appendChild(m);

      var side = el('div', 'saacc__row-side');
      var status = CASHBACK_STATUS[claim.status] || { label: claim.status, cls: 'saacc__badge--muted' };
      side.appendChild(el('span', 'saacc__badge ' + status.cls, status.label));
      var cb = euro(claim.cashbackEuros);
      if (cb) side.appendChild(el('span', 'saacc__price', cb));
      row.appendChild(side);
      container.appendChild(row);
    });
  }

  function renderCreator(card, container, creator, unavailable) {
    if (unavailable) {
      card.hidden = false;
      return showError(container, 'Creator-Daten sind gerade nicht verfügbar.');
    }
    if (!creator || !creator.active) {
      card.hidden = true;
      return;
    }
    card.hidden = false;
    container.textContent = '';

    var head = el('div', 'saacc__row');
    var main = el('div', 'saacc__row-main');
    main.appendChild(el('strong', null, creator.displayName || 'Creator'));
    var rate = Number.isFinite(Number(creator.commissionBp)) ? (Number(creator.commissionBp) / 100).toLocaleString('de-DE') + ' %' : '—';
    main.appendChild(el('small', null, 'Level: ' + (creator.commissionLevel || '—') + ' · Provision ' + rate));
    head.appendChild(main);
    var side = el('div', 'saacc__row-side');
    side.appendChild(el('span', 'saacc__badge saacc__badge--ok', (creator.pointsBalance || 0) + ' Punkte'));
    side.appendChild(el('span', 'saacc__badge saacc__badge--muted', (creator.clicks || 0) + ' Klicks'));
    head.appendChild(side);
    container.appendChild(head);

    if (creator.codes && creator.codes.length) {
      var codes = el('p', 'saacc__muted', 'Aktive Codes: ');
      creator.codes.slice(0, 6).forEach(function (code) {
        codes.appendChild(el('span', 'saacc__code', code.code));
      });
      container.appendChild(codes);
    }
  }

  function renderDesigns(container, designs, unavailable) {
    if (unavailable) return showError(container, 'Designs sind gerade nicht verfügbar.');
    if (!designs || !designs.length) {
      return showMuted(
        container,
        'Noch keine gespeicherten Veredelungs-Designs. Nach deiner ersten Veredelung erscheinen sie hier zum Wiederbestellen.'
      );
    }
    container.textContent = '';
    var grid = el('div', 'saacc__designs');
    designs.forEach(function (design) {
      var card = el('div', 'saacc__design');
      var img = el('div', 'saacc__design-img');
      if (design.imageUrl) img.style.backgroundImage = 'url("' + design.imageUrl + '")';
      card.appendChild(img);

      var body = el('div', 'saacc__design-body');
      body.appendChild(el('strong', null, design.title));
      body.appendChild(el('small', null, design.orderName + ' · ' + formatDate(design.orderedAt)));
      if (design.reorderUrl) {
        var btn = el('a', 'saacc__btn saacc__btn--primary saacc__btn--sm', 'Wieder bestellen');
        btn.href = design.reorderUrl;
        body.appendChild(btn);
      } else {
        body.appendChild(el('span', 'saacc__badge saacc__badge--muted', 'Auf Anfrage'));
      }
      card.appendChild(body);
      grid.appendChild(card);
    });
    container.appendChild(grid);
  }

  function renderWatchlist(container, watchlist, unavailable) {
    if (unavailable) return showError(container, 'Merkliste ist gerade nicht verfügbar.');
    if (!watchlist || !watchlist.items || !watchlist.items.length) {
      return showMuted(container, 'Keine Artikel auf der Merkliste. "Benachrichtigen" auf einer Produktseite fügt hier etwas hinzu.');
    }
    container.textContent = '';
    watchlist.items.forEach(function (item) {
      var row = el('div', 'saacc__row');
      var main = el('div', 'saacc__row-main');
      var title = item.productUrl ? el('a', null, item.productTitle || 'Artikel') : el('strong', null, item.productTitle || 'Artikel');
      if (item.productUrl) {
        title.href = item.productUrl;
        title.className = '';
      }
      main.appendChild(title);
      var detail = [item.colorName, item.sizeName || item.variantTitle].filter(Boolean).join(' · ');
      if (detail) main.appendChild(el('small', null, detail));
      row.appendChild(main);
      var side = el('div', 'saacc__row-side');
      side.appendChild(
        el(
          'span',
          'saacc__badge ' + (item.status === 'ready' ? 'saacc__badge--ok' : 'saacc__badge--warn'),
          item.status === 'ready' ? 'Wieder da' : 'Beobachtet'
        )
      );
      row.appendChild(side);
      container.appendChild(row);
    });
  }

  function renderSizes(root, list, profiles) {
    list.textContent = '';
    if (!profiles || !profiles.length) {
      list.appendChild(el('p', 'saacc__muted', 'Noch keine Größen-Profile. Lege unten das erste an.'));
      return;
    }
    profiles.forEach(function (profile) {
      var item = el('div', 'saacc__size-item');
      var main = el('div', 'saacc__row-main');
      main.appendChild(el('strong', null, profile.personName));
      var parts = [];
      if (profile.tops) parts.push('Oberteil ' + profile.tops);
      if (profile.bottoms) parts.push('Hose ' + profile.bottoms);
      if (profile.shoe) parts.push('Schuh ' + profile.shoe);
      if (profile.gloves) parts.push('Handschuh ' + profile.gloves);
      main.appendChild(el('small', null, parts.length ? parts.join(' · ') : 'Keine Größen hinterlegt'));
      item.appendChild(main);
      var del = el('button', 'saacc__del', 'Löschen');
      del.type = 'button';
      del.setAttribute('data-saacc-size-del', profile.id);
      item.appendChild(del);
      list.appendChild(item);
    });
  }

  function setupSizeProfiles(root) {
    var url = root.getAttribute('data-saacc-sizes-url');
    var list = root.querySelector('[data-saacc-size-list]');
    var form = root.querySelector('[data-saacc-size-form]');
    var status = root.querySelector('[data-saacc-size-status]');
    if (!url || !list || !form) return;

    function setStatus(kind, msg) {
      if (!status) return;
      status.className = 'saacc__size-status' + (kind ? ' is-' + kind : '');
      status.textContent = msg || '';
    }

    function refresh() {
      fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin', cache: 'no-store' })
        .then(function (res) {
          return res.text().then(function (text) {
            var trimmed = String(text || '').trim();
            if (!trimmed || trimmed.charAt(0) !== '{') throw new Error('invalid');
            var payload = JSON.parse(trimmed);
            if (!res.ok || !payload || !payload.success) throw new Error((payload && payload.error) || 'Fehler');
            renderSizes(root, list, payload.data.profiles);
          });
        })
        .catch(function () { showError(list, 'Größen-Profile sind gerade nicht verfügbar.'); });
    }

    function send(body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
        body: JSON.stringify(body),
      }).then(function (res) {
        return res.json().then(function (payload) {
          if (!res.ok || !payload || !payload.success) throw new Error((payload && payload.error) || 'Fehler');
          renderSizes(root, list, payload.data.profiles);
          return payload;
        });
      });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var data = new FormData(form);
      var personName = String(data.get('personName') || '').trim();
      if (!personName) { setStatus('err', 'Bitte einen Namen eingeben.'); return; }
      setStatus(null, 'Wird gespeichert …');
      send({
        action: 'save',
        id: String(data.get('id') || ''),
        personName: personName,
        tops: String(data.get('tops') || ''),
        bottoms: String(data.get('bottoms') || ''),
        shoe: String(data.get('shoe') || ''),
        gloves: String(data.get('gloves') || ''),
      })
        .then(function () { form.reset(); setStatus('ok', 'Gespeichert.'); })
        .catch(function (error) { setStatus('err', error.message || 'Speichern fehlgeschlagen.'); });
    });

    list.addEventListener('click', function (event) {
      var btn = event.target.closest('[data-saacc-size-del]');
      if (!btn) return;
      if (!window.confirm('Dieses Größen-Profil wirklich löschen?')) return;
      setStatus(null, 'Wird gelöscht …');
      send({ action: 'delete', id: btn.getAttribute('data-saacc-size-del') })
        .then(function () { setStatus('ok', 'Gelöscht.'); })
        .catch(function (error) { setStatus('err', error.message || 'Löschen fehlgeschlagen.'); });
    });

    refresh();
  }

  function renderProfile(container, profile) {
    if (!profile) return showError(container, 'Profil ist gerade nicht verfügbar.');
    container.textContent = '';

    var row = el('div', 'saacc__row');
    var main = el('div', 'saacc__row-main');
    var fullName = [profile.firstName, profile.lastName].filter(Boolean).join(' ');
    main.appendChild(el('strong', null, fullName || 'StrongAnt Kunde'));
    if (profile.email) main.appendChild(el('small', null, profile.email));
    if (profile.phone) main.appendChild(el('small', null, profile.phone));
    row.appendChild(main);
    var side = el('div', 'saacc__row-side');
    side.appendChild(
      el(
        'span',
        'saacc__badge ' + (profile.acceptsMarketing ? 'saacc__badge--ok' : 'saacc__badge--muted'),
        profile.acceptsMarketing ? 'Newsletter aktiv' : 'Kein Newsletter'
      )
    );
    row.appendChild(side);
    container.appendChild(row);

    (profile.addresses || []).forEach(function (addr) {
      var block = el('div', 'saacc__addr');
      var line1 = el('strong', null, addr.name || '');
      if (addr.isDefault) line1.appendChild(el('span', 'saacc__badge saacc__badge--muted', 'Standard'));
      block.appendChild(line1);
      var parts = [];
      if (addr.company) parts.push(addr.company);
      parts.push(addr.address1 + (addr.address2 ? ', ' + addr.address2 : ''));
      parts.push(addr.zip + ' ' + addr.city);
      if (addr.country) parts.push(addr.country);
      block.appendChild(document.createTextNode(' '));
      block.appendChild(document.createTextNode(parts.join(' · ')));
      container.appendChild(block);
    });
  }

  function parseJsonResponse(res, text) {
    var trimmed = String(text || '').trim();
    if (!trimmed || trimmed.charAt(0) !== '{') {
      if (res.status >= 500 || trimmed.slice(0, 15).toLowerCase().indexOf('<!doctype') >= 0) {
        throw new Error('Dashboard vorübergehend nicht erreichbar. Bitte Seite neu laden.');
      }
      throw new Error('Dashboard konnte nicht geladen werden.');
    }
    var payload;
    try {
      payload = JSON.parse(trimmed);
    } catch (error) {
      throw new Error('Dashboard vorübergehend nicht erreichbar. Bitte Seite neu laden.');
    }
    if (res.status === 401) {
      var unauthorized = new Error((payload && payload.error) || 'Nicht autorisiert.');
      unauthorized.code = 401;
      throw unauthorized;
    }
    if (!res.ok || !payload || !payload.success) {
      throw new Error((payload && payload.error) || 'Dashboard konnte nicht geladen werden.');
    }
    return payload.data || {};
  }

  function fetchDashboard(url) {
    return fetch(url, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (res) {
      return res.text().then(function (text) {
        return parseJsonResponse(res, text);
      });
    });
  }

  function setAuthState(root, loggedIn) {
    var dash = root.querySelector('[data-saacc-dashboard]');
    var login = root.querySelector('[data-saacc-login]');
    if (dash) dash.hidden = !loggedIn;
    if (login) login.hidden = loggedIn;
  }

  function applyGreeting(root, profile) {
    var greeting = root.querySelector('[data-saacc-greeting]');
    if (!greeting || !profile) return;
    var name = String(profile.firstName || profile.lastName || '').trim();
    greeting.textContent = name ? 'Hallo ' + name : 'Hallo';
  }

  function isUnauthorized(error) {
    if (!error) return false;
    if (error.code === 401) return true;
    return /Nicht autorisiert/i.test(String(error.message || ''));
  }

  function justReturnedFromAuth() {
    try {
      return /konto\.strongant\.de|customer_authentication/i.test(String(document.referrer || ''));
    } catch (e) {
      return false;
    }
  }

  function load(root, attempt) {
    var url = root.getAttribute('data-saacc-url');
    var orderChangeUrl = root.getAttribute('data-saacc-order-change-url');
    var stockShortfallUrl = root.getAttribute('data-saacc-stock-shortfall-url');
    var logoUploadUrl = root.getAttribute('data-saacc-logo-upload-url');
    var commsUrl = root.getAttribute('data-saacc-comms-url') || '/apps/design-factory/customer-portal/comms';
    if (!url) return;
    var retry = attempt || 0;
    var awaitingAuthSync = justReturnedFromAuth();

    var ordersBox = root.querySelector('[data-saacc-orders]');
    var stockShortfallsBox = root.querySelector('[data-saacc-stock-shortfalls]');
    var cashbackBox = root.querySelector('[data-saacc-cashback]');
    var creatorCard = root.querySelector('[data-saacc-creator-card]');
    var creatorBox = root.querySelector('[data-saacc-creator]');
    var designsBox = root.querySelector('[data-saacc-designs]');
    var watchlistBox = root.querySelector('[data-saacc-watchlist]');
    var profileBox = root.querySelector('[data-saacc-profile]');
    var commsBox = root.querySelector('[data-saacc-comms]');
    var commsStatus = root.querySelector('[data-saacc-comms-status]');
    var loginStatus = root.querySelector('[data-saacc-login-status]');

    if (loginStatus && awaitingAuthSync && retry === 0) {
      loginStatus.textContent = 'Anmeldung wird geprüft …';
    }

    fetchDashboard(url)
      .then(function (data) {
        setAuthState(root, true);
        applyGreeting(root, data.profile);

        var orders = data.orders || [];
        var cashback = data.cashback;
        var creator = data.creator;
        var designs = data.designs || [];

        setKpi(root, 'orders', String((data.profile && data.profile.ordersCount) || orders.length || 0));
        setKpi(root, 'cashback', (cashback && euro(cashback.availableEuros || cashback.balanceEuros)) || '0,00 €');
        setKpi(root, 'points', String((creator && creator.active && creator.pointsBalance) || 0));
        setKpi(root, 'designs', String(designs.length || 0));

        if (ordersBox) renderOrders(
          ordersBox,
          orders,
          data.ordersUnavailable,
          data.orderChanges || [],
          orderChangeUrl,
          logoUploadUrl,
          data.profile,
          data.personalizationOptions,
          root
        );
        if (stockShortfallsBox) renderStockShortfalls(
          stockShortfallsBox,
          data.stockShortfalls,
          data.stockShortfallsUnavailable,
          stockShortfallUrl
        );
        if (cashbackBox) renderCashback(cashbackBox, cashback, data.cashbackUnavailable);
        if (creatorCard && creatorBox) renderCreator(creatorCard, creatorBox, creator, data.creatorUnavailable);
        if (designsBox) renderDesigns(designsBox, designs, data.designsUnavailable);
        if (watchlistBox) renderWatchlist(watchlistBox, data.watchlist, data.watchlistUnavailable);
        if (profileBox) renderProfile(profileBox, data.profile);
        if (commsBox) renderComms(commsBox, root, data.comms, commsUrl);
        if (commsStatus) {
          var waiting = data.comms && data.comms.waitingForCustomer ? Number(data.comms.waitingForCustomer) : 0;
          commsStatus.textContent = waiting > 0 ? waiting + ' offen' : 'Chat aktiv';
          commsStatus.className = waiting > 0 ? 'saacc__badge saacc__badge--warn' : 'saacc__badge saacc__badge--ok';
        }
        startCommsPresence(root, commsUrl);
        setupSizeProfiles(root);
        if (String(window.location.hash || '') === '#saacc-nachrichten' || new URLSearchParams(window.location.search).get('comms')) {
          var nachrichten = root.querySelector('#saacc-nachrichten');
          if (nachrichten) nachrichten.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      })
      .catch(function (error) {
        if (isUnauthorized(error)) {
          if (awaitingAuthSync && retry < 3) {
            window.setTimeout(function () { load(root, retry + 1); }, 700 * (retry + 1));
            return;
          }
          setAuthState(root, false);
          if (loginStatus) loginStatus.textContent = 'Du bist noch nicht angemeldet.';
          return;
        }
        var msg = error instanceof Error ? error.message : 'Dashboard konnte nicht geladen werden.';
        if (retry < 1 && /vorübergehend|nicht erreichbar/i.test(msg)) {
          window.setTimeout(function () { load(root, retry + 1); }, 1500);
          return;
        }
        setAuthState(root, true);
        if (ordersBox) showError(ordersBox, msg);
        if (stockShortfallsBox) showError(stockShortfallsBox, msg);
        if (cashbackBox) showError(cashbackBox, msg);
        if (designsBox) showError(designsBox, msg);
        if (watchlistBox) showError(watchlistBox, msg);
        if (profileBox) showError(profileBox, msg);
      });
  }

  var THEME_KEY = 'strongant-customer-portal-theme';

  function readTheme() {
    try {
      var stored = localStorage.getItem(THEME_KEY);
      if (stored === 'light' || stored === 'dark') return stored;
    } catch (e) {}
    var boot = document.documentElement.getAttribute('data-saacc-theme-boot');
    if (boot === 'light' || boot === 'dark') return boot;
    return 'light';
  }

  function applyTheme(root, theme) {
    var next = theme === 'dark' ? 'dark' : 'light';
    root.setAttribute('data-saacc-theme', next);
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch (e) {}
    var label = root.querySelector('[data-saacc-theme-label]');
    if (label) label.textContent = next === 'dark' ? 'Dunkel' : 'Hell';
    var btn = root.querySelector('[data-saacc-theme-toggle]');
    if (btn) {
      btn.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
      btn.setAttribute('aria-label', next === 'dark' ? 'Helles Design aktivieren' : 'Dunkles Design aktivieren');
    }
  }

  function setupTheme(root) {
    applyTheme(root, readTheme());
    var btn = root.querySelector('[data-saacc-theme-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var current = root.getAttribute('data-saacc-theme') === 'dark' ? 'dark' : 'light';
      applyTheme(root, current === 'dark' ? 'light' : 'dark');
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-saacc]');
    if (!root) return;
    setupTheme(root);
    load(root);
  });
})();
